export const SLACK_APPSTORE_INSTALL_BUTTON_UTM_TAGS = 'utm_source=slack&utm_medium=directory&utm_campaign=install'